export const TAG_SIZES = {
  default_small: {
    borderRadius: "var(--border-radius-2)",
    height: "var(--space-5)",
    paddingTop: "var(--space-05)",
    paddingLeft: "var(--space-1)",
    paddingBottom: "var(--space-05)",
    paddingRight: "var(--space-1)",
  },
  default_medium: {
    borderRadius: "var(--border-radius-2)",
    height: "var(--space-7)",
    paddingTop: "var(--space-1)",
    paddingLeft: "var(--space-2)",
    paddingBottom: "var(--space-1)",
    paddingRight: "var(--space-2)",
  },
  pill_small: {
    borderRadius: "var(--border-radius-half)",
    height: "var(--space-5)",
    paddingTop: "var(--space-05)",
    paddingLeft: "var(--space-2)",
    paddingBottom: "var(--space-05)",
    paddingRight: "var(--space-2)",
  },
  pill_medium: {
    borderRadius: "var(--border-radius-half)",
    height: "var(--space-7)",
    paddingTop: "var(--space-1)",
    paddingLeft: "var(--space-2)",
    paddingBottom: "var(--space-1)",
    paddingRight: "var(--space-2)",
  },
  avatar_medium: {
    borderRadius: "var(--border-radius-half)",
    height: "var(--space-7)",
    paddingTop: "var(--space-05)",
    paddingLeft: "var(--space-05)",
    paddingBottom: "var(--space-05)",
    paddingRight: "var(--space-2)",
  },
} as const;
